import { ListChecks, Network } from 'lucide-react'
import type { ProjectTask, FdeCopy } from '@/frontend/features/Fde/types'

export default function TaskStructureBadges({
  task,
  copy,
  showParent = true,
}: {
  task: ProjectTask
  copy: FdeCopy
  showParent?: boolean
}) {
  return (
    <span className="inline-flex items-center gap-2 text-[10px] text-muted-foreground">
      {task.category && (
        <span className="max-w-28 truncate rounded bg-muted px-1.5 py-0.5">
          {task.category.name}
        </span>
      )}
      {showParent && task.parent_task && (
        <span title={task.parent_task.title}>{task.parent_task.identifier}</span>
      )}
      {Boolean(task.subtask_progress?.total) && (
        <span className="inline-flex items-center gap-1" title={copy.management.subtasks}>
          <Network className="size-3" />
          {task.subtask_progress!.completed}/{task.subtask_progress!.total}
        </span>
      )}
      {Boolean(task.checklist_progress?.total) && (
        <span className="inline-flex items-center gap-1" title={copy.management.checklist}>
          <ListChecks className="size-3" />
          {task.checklist_progress!.completed}/{task.checklist_progress!.total}
        </span>
      )}
    </span>
  )
}
